<template>
 <div class="evmodel" style="height:100%">
    <!-- <el-button type="primary" size="mini" class="modbot" @click="showinfo()">{{msg}}</el-button> -->
     <div id="centne" v-show="showin">
         <i class="el-icon el-icon-close" style="cursor:pointer;float:right;position:absolute;top:3px;right:5px" @click="close()"></i>
         <h4 style="margin:0;color:white">名称：Mcar</h4>
         <p>id:787878</p>
         <p>高度：18米</p>
         <p>标签：模型</p>
         <p>简介：显示模型属性信息，如名称、ID、高度等</p>
     </div>
    <div id="container"></div>
    <div id="loadingOverlay"><h1>Loading........</h1></div>
 </div>
</template>
<script>
import util from '../../components/util'

export default {
    data () {
        return {
        msg:'点击模型',
        viewer:null,
        showin:false,
        id:null,
        name:'',
        pos:null
        }
    },
    mounted () {
       var loa=document.getElementById('loadingOverlay');
       setTimeout(()=>{
           loa.style.display="none";
       },4000);
       this.init();
    },
    methods:{
        init() {
            this.viewer=util.getViewer('container',{
                 terrainProvider: Cesium.createWorldTerrain()
            });
            var position = new Cesium.Cartesian3(-1371108.6511167218, -5508684.080096612, 2901825.449865087);
            var heading = Cesium.Math.toRadians(180);
            var pitch = Cesium.Math.toRadians(2);
            var roll = Cesium.Math.toRadians(-6);
            var hpr = new Cesium.HeadingPitchRoll(heading, pitch, roll);
            var orientation = Cesium.Transforms.headingPitchRollQuaternion(position, hpr);
            var model = this.viewer.entities.add({
                name : 'truck',
                position : position,
                orientation : orientation,
                model : {
                    uri : '/demo/static/data/models/car.glb',
                    id:'car',
                    heightReference : Cesium.HeightReference.CLAMP_TO_GROUND,
                    minimumPixelSize : 128,
                    maximumScale : 20,
                    scale : 8.0,
                    runAnimations : false
                }
            });
            var frontView =  {
                destination : new Cesium.Cartesian3(-1371214.9554156072, -5508700.8494476415, 2901826.794611029),
                orientation : {
                    heading : Cesium.Math.toRadians(80.5354269423926),
                    pitch : Cesium.Math.toRadians(-15.466062969558285),
                    roll : Cesium.Math.toRadians(359.9999999526579)
                },
                maximumHeight : 100
            };
            this.viewer.scene.camera.flyTo({
                destination : frontView.destination,
                orientation :  frontView.orientation,
                duration : 5.0,
                pitchAdjustHeight : 20
            });
            var handler = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);
            handler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
            handler.removeInputAction(Cesium.ScreenSpaceEventType.RIGHT_CLICK);
            var info= document.getElementById('centne');
       
            handler.setInputAction((event)=>{
            var cartesian = this.viewer.scene.globe.pick(this.viewer.scene.camera.getPickRay(event.position), this.viewer.scene);
            var picks = Cesium.SceneTransforms.wgs84ToWindowCoordinates(this.viewer.scene, cartesian);
            var _pm_position = { x: picks.x, y: picks.y };
            var pick=this.viewer.scene.pick(event.position);
                if((Cesium.defined(pick))&& (pick.id)){
                    info.style.top=event.position.y + 'px';
                    info.style.left=event.position.x + 'px';
                };
                    this.showin=true;
               },Cesium.ScreenSpaceEventType.LEFT_CLICK);
                handler.setInputAction(()=>{
                       if (this.showin=true){
                          this.showin=false
                       }
                  },Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK);
                  handler.setInputAction(()=>{
                   if (this.showin=true){
                          this.showin=false
                       }
                  },Cesium.ScreenSpaceEventType.LEFT_DOWN);
                   handler.setInputAction(()=>{
                    if (this.showin=true){
                          this.showin=false
                       }
                  },Cesium.ScreenSpaceEventType.LEFT_UP);
                   handler.setInputAction(()=>{
                  if (this.showin=true){
                          this.showin=false
                       }
                  },Cesium.ScreenSpaceEventType.MIDDLE_CLICK);
                   handler.setInputAction(()=>{
                   if (this.showin=true){
                          this.showin=false
                       }
                  },Cesium.ScreenSpaceEventType.RIGHT_CLICK);
                  handler.setInputAction(()=>{
                  if (this.showin=true){
                          this.showin=false
                       }
                  },Cesium.ScreenSpaceEventType.RIGHT_DOWN);
                   handler.setInputAction(()=>{
                   if (this.showin=true){
                          this.showin=false
                       }
                  },Cesium.ScreenSpaceEventType.RIGHT_UP);
               
        },
        showinfo() {
            // var handler = new Cesium.ScreenSpaceEventHandler(this.viewer.scene.canvas);
            // handler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
            // handler.removeInputAction(Cesium.ScreenSpaceEventType.RIGHT_CLICK);
            // var info= document.getElementById('centne');
            // handler.setInputAction((event)=>{
            // var cartesian = this.viewer.scene.globe.pick(this.viewer.scene.camera.getPickRay(event.position), this.viewer.scene);
            // var picks = Cesium.SceneTransforms.wgs84ToWindowCoordinates(this.viewer.scene, cartesian);
            // var _pm_position = { x: picks.x, y: picks.y };
            // var pick=this.viewer.scene.pick(event.position);
            //     if((Cesium.defined(pick))&& (pick.id)){
            //         info.style.top=event.position.y + 'px';
            //         info.style.left=event.position.x + 'px';
            //         this.showin=true;
            //     }
            //  handler.destroy();
             //弹出框随漫游移动
            //  var _pm_position_2;
            //  this.viewer.scene.postRender.addEventListener((e)=>{
                // this.showin=false;
                // if(_pm_position != _pm_position_2){
                // _pm_position_2 = Cesium.SceneTransforms.wgs84ToWindowCoordinates(this.viewer.scene, cartesian);
                // var popw = document.getElementById("centne").offsetWidth;
                // var poph = document.getElementById("centne").offsetHeight;
                // console.log(popw,poph);
                // console.log(_pm_position_2)
                // var trackPopUpContent_ = window.document.getElementById("centne");
                // trackPopUpContent_.style.left = _pm_position_2.x-70+"px";
                // trackPopUpContent_.style.top = _pm_position_2.y - (poph + 50) + "px";
                //      }
            //  })
            // this.viewer.scene.postRender.addEventListener((e)=>{
            //     //  this.showin=false;
            // })

            // },Cesium.ScreenSpaceEventType.LEFT_CLICK);
            // handler.setInputAction(()=>{
            //     //   alert(777)
            // },Cesium.ScreenSpaceEventType.LEFT_DOWN)
        },

        close(){
            this.showin=false;
        }
    }
}
</script>
<style scoped>
 #container {
     width:100%;
     height: 100%;
 }
 .modbot{
     position: absolute;
     z-index: 10;
     margin-top: 10px;
     margin-left: 20px;
 }
#centne{
    height: 180px;
    width: 210px;
    background-color: rgba(0, 0, 0, 0.5);
    position: absolute;
    left: 30%;
    top:30%;
    padding-top: 6px;
    font-size: 16px;
    padding-left: 16px;
    padding-right: 16px;
    padding-top: 6px;
    z-index: 10;
    color:white;
}
#centne >p{
    margin: 0;
    padding-top: 6px;
}
</style>